import { render, staticRenderFns } from "./PlansPage.vue?vue&type=template&id=55f58651&scoped=true&"
import script from "./PlansPage.vue?vue&type=script&lang=ts&"
export * from "./PlansPage.vue?vue&type=script&lang=ts&"
import style0 from "./PlansPage.vue?vue&type=style&index=0&id=55f58651&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f58651",
  null
  
)

export default component.exports